<template>
  <div class="container">
    <div class="header">
      <ul>
        <li class="left h_coin">当前金币：<span class="h_icon"></span>{{gold}}</li>
        <li class="right"
            @click="toRouter">我的奖品<span class="h_right"></span></li>
      </ul>
    </div>
    <div class="notice">
      <!-- 动态滚动 -->
      <div class="marquee"
           v-if="marqueeList.length>0">
        <div class="marquee_box">
          <ul class="marquee_list"
              :class="{marquee_top:animate}">
            <li v-for="(item, index) in marqueeList"
                :key="index">
              <span class="icon_lb"></span>
              <span>{{item.title}}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 恭喜175****3753抽到了50金币 -->
    </div>
    <div id="rotary-table">
      <div class="box">
        <div class="award"
             v-for="(item,index) in awards"
             :key="index"
             :class="{'active': current==index,'noMg':index==2||index==5||index==8,'gray':isStart&&index==4,'btnAct':index==4}"
             @click="start(index)">
          <div v-if="index!==4">
            <img class="icon1"
                 :src="item.iconUrl" />
            <p class="awardName"
               :class="{'ps':index==3||index==7}">{{item.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <h1 class="title"><span class="leftIcon"></span>活动规则<span class="rightIcon"></span></h1>
      <ul>
        <li>1、用户连续签到第3天和第7天可参与抽奖；</li>
        <li>2、中奖后，将在24小时内发放奖品，如有未发放的情况请反馈客服；</li>
        <li>3、如有作弊行为，一经发现，取消中奖资格，并保留追究责任的权利；</li>
        <li>4、本活动奖品与苹果公司无关，最终解释权归77信用所有。</li>
      </ul>
    </div>
    <MessageInfo :propJson="propJson"
                 @sureClick="sureClick" />
  </div>
</template>
<script>
import MessageInfo from '@/components/messageInfo';
export default {
  components: {
    MessageInfo
  },
  name: 'raffle',
  data () {
    return {
      gold: '',
      marqueeList: [
        {
          title: '恭喜175****3753抽到了50金币',
        }, {
          title: '恭喜132****2358抽到了10金币',
        }, {
          title: '恭喜134****5742抽到了20金币',
        }, {
          title: '恭喜183****6832抽到了5金币',
        }, {
          title: '恭喜137****3836抽到了腾讯会员',
        }, {
          title: '恭喜177****6171抽到了10金币',
        }, {
          title: '恭喜150****4981抽到了10金币',
        }, {
          title: '恭喜151****7163抽到了20金币',
        }, {
          title: '恭喜156****3610抽到了5金币',
        }, {
          title: '恭喜152****8198抽到了爱奇艺员',
        }
      ],
      animate: false,
      propJson: {
        title: '提示',
        message: '恭喜您抽中了“爱奇艺VIP7天优惠券”，已放入您的账户！',
        cacleBtn: '好的',
        isCacleClick: true,
        showToast: false,
        isSecond: false,
      },
      current: -1,//当前转动到哪个位置，起点位置
      awards: [
        // { id: 1, name: '5金币' },
        // { id: 2, name: '10金币' },
        // { id: 3, name: '50金币' },
        // { id: 4, name: '腾讯视频7天优惠券' },
        // { id: 5, name: '点击抽奖' },
        // { id: 6, name: '5金币' },
        // { id: 7, name: '10金币' },
        // { id: 8, name: '爱奇艺会员7天优惠券' },
        // { id: 9, name: '20金币' }
      ],
      speed: 200,//初始转动速度
      diff: 15,
      award: {},
      time: 0,//转动次数
      isStart: false,//是否可以
    };
  },
  mounted () {
    this.getList();
    this.util.title('签到抽奖');
    setInterval(this.showMarquee, 2000)
  },
  methods: {
    getList () {
      let _this = this;
      this.$get('/app/valueAdded/lotteryPage', {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.gold = e.data.gold;
            _this.awards = e.data.lotteryView;
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    toRouter () {
      // 进入我的奖品
      this.$router.push({
        path: '/vipActive/myPrize',
        query: {
          customerId: '3509'
        }
      });
    },
    showMarquee: function () {
      this.animate = true;
      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500);
    },
    sureClick () {
      //去奖品页面
      this.propJson.showToast = false;
      this.toRouter();
    },
    start (index) {
      if (!this.isStart && index == 4) {
        this.isStart = true;
        // 开始抽奖
        this.drawAward();
        this.time = Date.now();
        this.speed = 200;
        this.diff = 15;
      }

    },
    drawAward () {
      // // 请求接口, 这里我就模拟请求后的数据(请求时间为2s)
      // setTimeout(() => {
      //   this.award = {
      //     id: '2',
      //     name: '金币',
      //   };
      // }, 1000);
      this.toLottery()
      // this.move()

    },
    toLottery () {
      let _this = this;
      this.$post('/app/valueAdded/lottery', {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.award = {
              id: e.data.id,
              name: e.data.name
            }
            _this.move();
          }
          else {
            _this.isStart = false;
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    move () {
      let _this = this;
      window.timeout = setTimeout(() => {
        _this.current++;
        if (_this.current > 8) {
          _this.current = 0;
        }
        if (_this.award.id && (Date.now() - _this.time) / 1000 > 2) {
          _this.speed += _this.diff;
          if ((Date.now() - _this.time) / 1000 > 4 && _this.award.id == _this.awards[_this.current].id) {
            clearTimeout(window.timeout);
            setTimeout(() => {
              if (_this.award.id == 4 || _this.award.id == 8) {
                _this.propJson.message = `恭喜您抽中了“` + _this.award.name + `”，已放入您的账户！`
                _this.propJson.cacleBtn = '稍后查看';
                _this.propJson.sureBtn = '前往查看';
                _this.propJson.isCacleClick = false,
                  _this.propJson.showToast = true;
              } else {
                _this.propJson.message = `恭喜您抽中了“` + _this.award.name + `”，已放入您的账户！`
                _this.propJson.showToast = true;
              }
              _this.isStart = false;
            }, 0);
            return;
          }
        } else {
          _this.speed -= this.diff;
        }
        console.log(_this.speed);
        _this.move();


      }, _this.speed);
    }
  }
};
</script>

<style rel="stylesheet/less" lang="less">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
}
.container {
  background: url("../../assets/img/vip/luck/coins_bg.png") no-repeat top center;
  background-size: cover;
  padding: 0.15rem;
  .header {
    color: #fff;
    font-size: 0.12rem;
    clear: both;
    overflow: hidden;
    .h_coin {
      width: 1.17rem;
      height: 0.24rem;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 16px;
      text-align: center;
      line-height: 0.23rem;
      .h_icon {
        display: inline-block;
        background: url("../../assets/img/vip/luck/coins1.png") no-repeat center
          center;
        background-size: 100% 100%;
        width: 0.16rem;
        height: 0.16rem;
        position: relative;
        top: 0.03rem;
        margin-right: 0.03rem;
      }
    }
    .h_right {
      display: inline-block;
      background: url("../../assets/img/vip/luck/icon_right.png") no-repeat
        center center;
      background-size: 100% 100%;
      width: 0.1rem;
      height: 0.1rem;
      position: relative;
      margin-left: 0.05rem;
      top: 0.01rem;
    }
  }
  .notice {
    position: absolute;
    color: #fff;
    text-align: center;
    font-size: 0.12rem;
    top: 1.45rem;
    z-index: 11;
    left: 0.7rem;
    .icon_lb {
      display: inline-block;
      background: url("../../assets/img/vip/luck/laba.png") no-repeat center
        center;
      background-size: 100% 100%;
      width: 0.12rem;
      height: 0.11rem;
      position: relative;
      margin-right: 0.05rem;
      top: 0.01rem;
    }
  }
  #rotary-table {
    width: 100%;
    height: 4.8rem;
    position: relative;
    margin: auto;
    margin-top: 0.04rem;
    background: url("../../assets/img/vip/luck/coins_header.png") no-repeat
      center center;
    background-size: 100% 100%;
    // background-color: antiquewhite;
    .box {
      position: relative;
      top: 1.44rem;
      clear: both;
      overflow: hidden;

      padding: 0 0.15rem;
      padding-left: 0.3rem;
      .item {
        display: flex;
        flex: 1;
        justify-content: space-between;
        padding: 0.15rem 0.28rem;
        padding-bottom: 0rem;
        padding-top: 0.1rem;
      }
      .icon1,
      .icon2,
      .icon3,
      .icon4,
      .icon5,
      .icon6 {
        // background: url("../../assets/img/vip/luck/coins1.png") no-repeat center
        //   center;
        // background-size: 100% 100%;
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        position: relative;
        top: 0.06rem;
      }
      .icon2 {
        background: url("../../assets/img/vip/luck/coins2.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .icon3 {
        background: url("../../assets/img/vip/luck/coins3.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .icon4 {
        background: url("../../assets/img/vip/luck/coins4.png") no-repeat center
          center;
        background-size: 100% 100%;
        position: relative;
        top: 0.07rem;
      }
      .icon5 {
        background: url("../../assets/img/vip/luck/coins5.png") no-repeat center
          center;
        background-size: 100% 100%;
        position: relative;
        top: 0.07rem;
      }
      .icon6 {
        background: url("../../assets/img/vip/luck/coins6.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
      .award {
        float: left;
        width: 30%;
        flex: 1;
        margin-right: 0.08rem;
        height: 0.93rem;
        text-align: center;
        background: url("../../assets/img/vip/luck/coinsBg.png") no-repeat
          center center;
        background-size: 100% 100%;
        // box-shadow: 0px 0px 10px 0px rgba(232, 102, 34, 1),
        //   0px -2px 0px 0px rgba(242, 169, 130, 1);
        border-radius: 9px;
        margin-top: 0.1rem;
        .awardName {
          font-size: 0.12rem;
          color: #995835;
          line-height: 0.14rem;
          width: 0.6rem;
          margin: 0 auto;
          text-align: center;
          position: relative;
          top: 0.06rem;
        }
        .ps {
          position: relative;
          top: -0.04rem;
        }
        &.active {
          background: url("../../assets/img/vip/luck/coinsBgAct.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
        &.btnAct {
          background: url("../../assets/img/vip/luck/coins_btnAct.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
        &.gray {
          background: url("../../assets/img/vip/luck/coins_btn.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
      }
      .noMg {
        margin-right: 0;
      }
    }
  }
  .info {
    background: url("../../assets/img/vip/luck/coins_footer.png") no-repeat
      center center;
    background-size: 100% 100%;
    width: 100%;
    padding: 0.15rem 0.1rem;
    font-size: 0.12rem;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(196, 65, 65, 1);
    line-height: 22px;
    .title {
      font-size: 0.12rem;
      text-align: center;
      margin-top: 0.15rem;
      font-weight: 500;
      margin-bottom: 0.1rem;
      .leftIcon,
      .rightIcon {
        background: url("../../assets/img/vip/luck/title_left.png") no-repeat
          center center;
        background-size: 100% 100%;
        width: 0.32rem;
        height: 0.1rem;
        display: inline-block;
        margin-right: 0.05rem;
      }
      .rightIcon {
        background: url("../../assets/img/vip/luck/title_right.png") no-repeat
          center center;
        background-size: 100% 100%;
        margin-left: 0.05rem;
      }
    }
    ul {
      line-height: 26px;
    }
  }
}
.marquee {
  width: 100%;
  height: 0.3rem;
  align-items: center;
  /* color: #3a3a3a; */
  /* background-color: #b3effe; */
  display: flex;
  box-sizing: border-box;
}

.marquee_title {
  padding: 0 20px;
  height: 30px;
  font-size: 14px;
  border-right: 1px solid #d8d8d8;
  align-items: center;
}

.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 0.3rem;
  overflow: hidden;
  width: 2.41rem;
  margin: 0 auto;
}

.marquee_list {
  display: block;
  color: #f7f7f7;
}

.marquee_top {
  transition: all 0.5s;
  margin-top: -30px;
}
.marquee_list li {
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.12rem;
}
</style>